import basePath from "base_path";
import ActionTypes, {WorkflowsActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {TestSet} from "common/flowmaster/types/test";

export type TestSetFetchAction = {
  type: WorkflowsActionTypes["TESTSETS_FETCH"]["SUCCESS"];
  payload: TestSet[];
};

export default function fetchTestSets(requestor) {
  return createReduxPromiseAction(
    ActionTypes.TESTSETS_FETCH,
    (organisationId: OrganisationId) => {
      return requestor
        .get(`${basePath}/organisation/${organisationId}/testset`, {
          withCredentials: true,
        })
        .then(response => {
          return response.data;
        });
    },
  );
}
